import { Row, FormInput, FormSelect, Widget, FormContext } from '@digital/ui'
import React, { useContext, useEffect, useState } from 'react'
import ptBR from '@app/i18n/ptBR'
import { solicitacaoIdState, solicitacaoState } from '../../../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getSaldosNaoPrevisto, getSolicitacaoNaoPrevisto, updateSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';
import { Collapse, Icon } from 'antd';
import { EStatusSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { getColaboradoresComAdUserOptions } from '@app/api/naoPrevistos/naoConformidadeColaboradoIntegracao';
import { hasPermission } from '@app/helpers/permissions';

const { Panel } = Collapse;

interface IDescricaoDoProjetoOuInvestimentoProps {
  noCollapse?: boolean;
}

const DescricaoDoProjetoOuInvestimento = ({ noCollapse }: IDescricaoDoProjetoOuInvestimentoProps) => {
  const { formProps } = useContext(FormContext);
  const solicitacaoId = useRecoilValue(solicitacaoIdState)
  const [solicitacao, setSolicitacao] = useRecoilState(solicitacaoState);
  const [responsavelState, setResponsanvelState] = useState('')
  const [saldoGA, setSaldoGA] = useState(0)
  const [saldoDR, setSaldoDR] = useState(0)

  const onSelect = (value: any, property: string) => {
    if (solicitacao[property] === value) return
    const values = { ...solicitacao, [property]: value }
    updateSolicitacaoNaoPrevisto(values).then(() => {
      if (property === 'adUserResponsavel' && solicitacaoId) {
        getSolicitacaoNaoPrevisto(solicitacaoId).then((updated) => {
          if (updated && updated.id && solicitacao) {
            const merged = { ...solicitacao, ...updated }
            setSolicitacao(merged)
            if (formProps && formProps.setFieldsValue) {
              formProps.setFieldsValue(merged)
            }
          }
        })
      } else {
        setSolicitacao((prev) => (prev ? { ...prev, [property]: value } : prev))
      }
    })
  }

  useEffect(() => {

    if (hasPermission(['NAO_PREVISTO_ADMINISTRADOR']) && solicitacao.areaResponsavel && solicitacao.diretoriaResponsavel && responsavelState !== JSON.stringify({ areaResponsavel: solicitacao.areaResponsavel, diretoriaResponsavel: solicitacao.diretoriaResponsavel }) {
      setResponsanvelState(JSON.stringify({ areaResponsavel: solicitacao.areaResponsavel, diretoriaResponsavel: solicitacao.diretoriaResponsavel }))
      getSaldosNaoPrevisto(solicitacao.areaResponsavel, solicitacao.diretoriaResponsavel, solicitacao.tipo).then(result => {
        if (!result) {
          setSaldoDR(0)
          setSaldoGA(0)
          return
        }
        setSaldoDR(result?.saldoDR)
        setSaldoGA(result?.saldoGA)
      })
    }

  }, [solicitacao.areaResponsavel, solicitacao.diretoriaResponsavel])

  const content = (
          <Widget
            title=""
            actions={[]}>


            <fieldset>
              <legend className='legend-float-left'>{ptBR.lblSolicitante}</legend>

              <Row>
                <FormSelect
                  span={6}
                  name='nomeSolicitante'
                  label={ptBR.lblNome}
                  showSearch
                  disabled
                />

                <FormInput
                  span={6}
                  name='funcaoSolicitante'
                  label={ptBR.lblFuncao}
                  disabled
                />
              </Row>

              <Row>
                <FormInput
                  span={4}
                  name='diretoriaSolicitante'
                  label={ptBR.diretoria}
                  disabled
                />

                <FormInput
                  span={4}
                  name='areaSolicitante'
                  label={ptBR.area}
                  disabled
                />

                <FormInput
                  span={4}
                  name='departamentoSolicitante'
                  label={ptBR.departamento}
                  disabled
                />
              </Row>
            </fieldset>

            <fieldset>
              <legend className='legend-float-left'>{ptBR.lblResponsavel}</legend>

              <Row>
                <FormSelect
                  span={6}
                  showSearch
                  name='adUserResponsavel'
                  label={ptBR.lblNome}
                  getOptions={getColaboradoresComAdUserOptions}
                  onSelect={(value) => {
                    onSelect(value, 'adUserResponsavel')
                  }}
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.PreenchimentoDaSolicitacao}
                />

                <FormInput
                  span={6}
                  name='funcaoResponsavel'
                  label={ptBR.lblFuncao}
                  disabled
                />
              </Row>

              <Row>
                <FormInput
                  span={4}
                  name='diretoriaResponsavel'
                  label={ptBR.diretoria}
                  disabled
                />

                <FormInput
                  span={4}
                  name='areaResponsavel'
                  label={ptBR.area}
                  disabled
                />

                <FormInput
                  span={4}
                  name='departamentoResponsavel'
                  label={ptBR.departamento}
                  disabled
                />
              </Row>
            </fieldset>

            {
              hasPermission(['NAO_PREVISTO_ADMINISTRADOR']) ? <fieldset>
                <legend className='legend-float-left'>Saldos</legend>

                <Row>
                  <FormInput
                    span={6}
                    name='GA'
                    label="GA"
                    value={saldoGA}
                    disabled
                  />

                  <FormInput
                    span={6}
                    name='DR'
                    label='DR'
                    value={saldoDR}
                    disabled
                  />

                </Row>
              </fieldset> : (
                () => { }
              )
            }


          </Widget>
  );

  if (noCollapse) return content;
  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header={ptBR.lblSolicitante} style={{ border: 0 }}>
          {content}
        </Panel>
      </Collapse>
    </>
  );
}

export default DescricaoDoProjetoOuInvestimento